import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../layout/theme-next/provider';

export const styles = makeStyles<NextTheme>((theme) =>
  createStyles({
    highlight: {
      color: 'red',
    },
    actionLink: {
      textDecoration: 'none',
      color: 'inherit',
    },
    containerWrap: {
      paddingLeft: '42px',
      marginTop: '15px',
      marginBottom: '15px',
    },
    itemWrap: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
  },
  ));
